import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';

import { TenantContactListComponent } from './tenant-contact/list/tenant-contact-list.component';

@Component({
  selector: 'app-tenant-customer-list-page',
  standalone: true,
  imports: [TenantContactListComponent, TestIdDirective],
  template: ` <tenant-contact-list [tenantId]="tenantId" [tenantType]="tenantType" pageTitleKey="tenant.detail.contacts" testId="tenant-customer-list-page" /> `
})
export class TenantCustomerListPageComponent {
  private readonly route = inject(ActivatedRoute);

  readonly tenantId = this.route.snapshot.paramMap.get('tenantId') ?? '';
  readonly tenantType = this.readCurrentTenantType();

  private readCurrentTenantType(): string {
    try {
      const value = localStorage.getItem('current_tenant');
      return value ? (JSON.parse(value)?.type ?? '') : '';
    } catch {
      return '';
    }
  }
}
